import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterChange } from '../../../actions/index'

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CloseIcon from '@material-ui/icons/Close';

import { _ } from '../../../functions/translator.js';
import { FilterActions } from '../../../constants/constants.js';

class FormDropdown extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            selected: 0,
        }
    }

    handleFormChange = (event) => {
        this.setState({ selected: event.target.value });
        if (event.target.value === 0) {
            const customCardIds = Object.values(this.props.customcardsData).filter(
                customcard => this.props.customcardTypes.includes(customcard.attributes.type_)
            ).map(customcard => customcard.id);
            if (customCardIds.length === 0) {
                this.props.filterChange(FilterActions.CUSTOMCARD, null);
            } else {
                this.props.filterChange(FilterActions.CUSTOMCARD, customCardIds);
            }
        } else {
            this.props.filterChange(FilterActions.CUSTOMCARD, [event.target.value]);
        }
    };

    handleClose = (event) => {
        const customCardIds = Object.values(this.props.customcardsData)
            .filter(customcard => this.props.customcardTypes.includes(customcard.attributes.type_))
            .map(customcard => customcard.id);
        if (customCardIds.length === 0) {
            this.props.filterChange(FilterActions.CUSTOMCARD, null);
        } else {
            this.props.filterChange(FilterActions.CUSTOMCARD, customCardIds);
        }
        this.props.closeCallback(event);
    }

    render() {
        const options = [];
        options.push(
            <MenuItem value={0} key={0}>{_('Todo')}</MenuItem>,
        );
        let customcardsData = Object.values(this.props.customcardsData)
        customcardsData = customcardsData.filter(customcard => this.props.customcardTypes.includes(customcard.attributes.type_))
        for (const customcardData of customcardsData) {
            options.push(
                <MenuItem value={customcardData.id} key={customcardData.id}>
                    {customcardData.attributes.name}
                </MenuItem>
            );
        }
        return(
            <div className={this.props.extraClass}>
                <p className='text'>
                    { _('Formularios') }
                    <CloseIcon className='float-right cursor-pointer' data-type='customcards' onClick={this.handleClose}/>
                </p>
                <Select
                    value={this.state.selected}
                    onChange={this.handleFormChange}>
                    {options}
                </Select>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        customcardId    : state.filters.customcardId,
        customcardsData : state.projectData.customcards,
        customcardTypes : state.filters.customcardTypes,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange     : filterChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(FormDropdown);